import { H5 } from '../../../AbstractElements';
import React, { Fragment } from 'react';
import { CardHeader } from 'reactstrap';

const HeaderCard = ({ title, span1, span2, mainClasses, action }) => {
  return (
    <Fragment>
      <CardHeader className={`${mainClasses ? mainClasses : ''}`}>
        <div className="d-flex justify-content-between align-items-center w-100">
          {/* Left: Title */}
          <div>
            <H5 className="mb-0">{title}</H5>
            {span1 ? <span>{span1}</span> : ''}
            {span2 ? <span>{span2}</span> : ''}
          </div>

          {/* Right: Action */}
          {action && <div>{action}</div>}
        </div>
      </CardHeader>
    </Fragment>
  );
};

export default HeaderCard;